"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { useState } from "react";
import { Box } from "@mui/material";
import { Rating, Text } from "@nxt-costco-com/forge-components";
import { SpaceXs } from "@nxt-costco-com/forge-design-tokens";
import { Analytics } from "../../../../Analytics/index.js";
import { PillBadges } from "../../../../DataDisplay/PillBadges/index.js";
import { ProductImage } from "../../../ProductImage/index.js";
import { ProductSwatch } from "../../../ProductSwatch/index.js";
import { useProductTileData } from "../../../../../hooks/useProductTileData/index.js";
import { AvailabilityInfo } from "./AvailabilityInfo/index.js";
import { CostcoTravelBadge } from "./CostcoTravelBadge/index.js";
import { FSAEligibleInfoWrapper } from "./FSAEligibleInfoWrapper/index.js";
import { MemberOnlyItemBadge } from "./MemberOnlyItemBadge/index.js";
import { PriceGroup } from "./PriceGroup/index.js";
import { ProductDeliveryBadgeAddtoList } from "./ProductDeliveryBadgeAddtoList/index.js";
import { ProductInfo } from "./ProductInfo/index.js";
import { cardBodyContainerStyles, imageStyles, childElementStyles } from "./styles.js";
const CardBody = ({
  fsaConfig,
  showReviews,
  setPdpNavigationUrl,
  isHorizontal,
  maxImageHeight,
  productTileMaxLineNumber,
  minProductTileImageWidth,
  maxProductTileImageWidth,
  hideReviewStarValue,
  isCriteo,
  isCriteoCarousel,
  showPricing = true,
  showActionButton,
  cookieContext,
  enablePromoBreakdown
}) => {
  var _a;
  const { normalizedData, translationsConfig, productTitleId } = useProductTileData();
  const {
    productInfoData,
    isMemberOnlyItem,
    isCostcoTravel,
    isFsaEligible,
    isChdiEligible,
    reviewRatingData,
    pillBadges,
    colorSwatchesData,
    productDeliveryBadgeData
  } = normalizedData;
  const translations = translationsConfig == null ? void 0 : translationsConfig.translations;
  const { productImageUrl, productName, partNumber } = productInfoData;
  const [imageUrl, setImageUrl] = useState(
    productImageUrl
  );
  const [onPreviewImageUrl, setOnPreviewImageUrl] = useState(null);
  const onSwatchClick = (swatchData) => {
    const { pdpNavigationUrl, productImageUrl: productImageUrl2 } = swatchData || {};
    setImageUrl(productImageUrl2 || null);
    setPdpNavigationUrl(pdpNavigationUrl || null);
  };
  const onRemovePreview = () => {
    setOnPreviewImageUrl(null);
  };
  const onSwatchPreview = (swatchData) => {
    const { productImageUrl: productImageUrl2 } = swatchData || {};
    setOnPreviewImageUrl(productImageUrl2 || null);
  };
  const showGroceryItemPriceVaryText = !isCriteo && !isCriteoCarousel;
  const staticUniqueId = true;
  return /* @__PURE__ */ jsxs(
    Box,
    {
      sx: [
        cardBodyContainerStyles,
        {
          flexDirection: isHorizontal ? "row" : "column"
        }
      ],
      children: [
        /* @__PURE__ */ jsx(
          ProductImage,
          {
            src: onPreviewImageUrl || imageUrl || "",
            sx: {
              ...imageStyles,
              marginBottom: isHorizontal ? 0 : (_a = imageStyles) == null ? void 0 : _a.marginBottom,
              marginRight: isHorizontal ? SpaceXs : 0,
              maxHeight: maxImageHeight,
              maxWidth: maxProductTileImageWidth,
              minWidth: minProductTileImageWidth
            },
            ariaHidden: true,
            srcFallback: (translations == null ? void 0 : translations.noimgurl) || "",
            title: productName || "",
            titleFallback: (translations == null ? void 0 : translations.noimgtext) || "",
            uniqueId: partNumber
          }
        ),
        /* @__PURE__ */ jsxs(Box, { sx: cardBodyContainerStyles, children: [
          pillBadges && pillBadges.length > 0 && /* @__PURE__ */ jsx(
            PillBadges,
            {
              dataPrivate: Boolean(isFsaEligible || isChdiEligible),
              pillBadges,
              sx: childElementStyles,
              uniqueId: partNumber
            }
          ),
          /* @__PURE__ */ jsx(
            ProductDeliveryBadgeAddtoList,
            {
              showActionButton
            }
          ),
          isMemberOnlyItem && /* @__PURE__ */ jsx(MemberOnlyItemBadge, { uniqueId: partNumber }),
          isCostcoTravel && /* @__PURE__ */ jsx(CostcoTravelBadge, { uniqueId: partNumber }),
          colorSwatchesData && colorSwatchesData.length > 1 && /* @__PURE__ */ jsx(Analytics, { analyticData: { doNotTrack: true }, children: /* @__PURE__ */ jsx(
            ProductSwatch,
            {
              ariaDescribedBy: productTitleId,
              onPreview: onSwatchPreview,
              onRemovePreview,
              onSelect: onSwatchClick,
              swatches: colorSwatchesData,
              sx: childElementStyles,
              uniqueId: partNumber,
              variant: "compact"
            }
          ) }),
          isFsaEligible && fsaConfig && /* @__PURE__ */ jsx(FSAEligibleInfoWrapper, { fsaConfig }),
          showPricing && /* @__PURE__ */ jsx(
            PriceGroup,
            {
              productTileMaxLineNumber,
              cookieContext,
              enablePromoBreakdown
            }
          ),
          /* @__PURE__ */ jsx(
            ProductInfo,
            {
              productTileMaxLineNumber
            }
          ),
          showReviews && reviewRatingData && /* @__PURE__ */ jsx(
            Rating,
            {
              displayVariant: "compact",
              size: "small",
              ...reviewRatingData,
              displayAvgRatingAsText: hideReviewStarValue ? false : Boolean(
                reviewRatingData == null ? void 0 : reviewRatingData.displayAvgRatingAsText
              ),
              staticUniqueId,
              uniqueId: `ProductRating_${partNumber}`,
              emptyReviewText: (translations == null ? void 0 : translations.noreviews) || ""
            }
          ),
          productDeliveryBadgeData && showGroceryItemPriceVaryText && /* @__PURE__ */ jsx(Text, { color: "light", variant: "t7", children: (translations == null ? void 0 : translations.whavailabilitymsg) || "" }),
          !isCriteo && /* @__PURE__ */ jsx(AvailabilityInfo, {})
        ] })
      ]
    }
  );
};
export {
  CardBody
};
